import * as THREE from 'three';
import ObjectView from '../../views/object-view';
import Panel from '../../objects/panel';
import Beam from '../../objects/beam';
import { Screw } from '../../objects/screw';
// import { BRAND } from '@config';
// import { brandList } from './../../../app.values';

export default {
  name: 'general-calculation-object',
  ground: {
    depth: 100,
    padding: {
      C1x: null, // Null = ∞ char in UI
      C2x: null,
      C1y: null,
      C2y: null
    }
  },
  panel: {
    type: Panel.types.SQUARE,
    isClosed: false,
    width: 250,
    height: 250,
    depth: 8,
    color: 0x98cbea,
    animate: {
      move: {
        z: {
          active: false,
          fixed: false,
          value: null,
          units: null
        },
        x: {
          active: false,
          fixed: false,
          value: null,
          units: null
        },
        y: {
          active: false,
          fixed: false,
          value: null,
          units: null
        }
      },
      rotate: {
        z: {
          active: false,
          fixed: false,
          value: null,
          units: null
        },
        x: {
          active: false,
          fixed: false,
          value: null,
          units: null
        },
        y: {
          active: false,
          fixed: false,
          value: null,
          units: null
        }
      }
    }
  },
  beam: {
    width: 20,
    height: 100,
    depth: 20,
    type: Beam.types.SQUARE,
    edgeSize: 1,
    shift: {
      x: null,
      y: null
    },
    color: 0xc4a68b //BRAND === brandList.Sea ? 0xc4a68b : null
  },
  screw: {
    count: {
      n: 2, // Use triangle, square and circle
      m: 2, // Use triangle, square
      k: 0, // Use triangle
      ignorePositions: [] // For square, e.g. ignore center screw position
    },
    custom: {
      allow: false, // If user select n type screws
      active: false, // If user select specify coordinated
      positions: [] // Container screws positions
    },
    heightType: Screw.types.height.DEFAULT,
    types: [],
    padding: {
      // For triangle
      s: 120,
      // For square
      s1: 111,
      s2: 111,
      // For circle
      diameter: 120
    },
    coordinatesList: [], // Contain screw coordinates
    radius: 6
  },
  mode: ObjectView.mode.MODE_3D,
  camera2D: {
    position: new THREE.Vector3(0.001, 1345.362, 0)
  },
  characteristicsLoads: null
};




// WEBPACK FOOTER //
// ./src/object-view/generators/general-calculation/defaultOptions.js